// extracted by mini-css-extract-plugin
module.exports = {"container":"en","bubbleNav":"fn","graphic":"gn","container404":"hn","container500":"in","contact":"jn"};